import { ToastTone } from "./types"

export const DEFAULT_TIMEOUT = 5000
export const DEFAULT_TONE: ToastTone = `SUCCESS`
